import $ from "jquery";

$(document).ready(function () {
    teamAutocomplete();

    $('.btn-remove-group').on('click', function (event) {
        event.preventDefault();
        $(this).closest('.form__group').remove();
    });

});

function teamAutocomplete() {
    $('#away-team').attr('name', 'team[]');
    $('#home-team').attr('name', 'team[]');

    $.widget("custom.catcomplete", $.ui.autocomplete, {
        _create    : function () {
            this._super();
            this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
        },
        _renderItem: function (ul, item) {
            var template = "<li class='ui-menu-item' data-value='" + item.id + "' >\
						<div class='content'>\
							<h6>" + item.name + "</h6>\
						</div>\
						<div class='aside'>" + (item.meta ? item.meta : 'Football') + "</div>\
					</li>";

            var templateGame = "<li class='ui-menu-item' data-value='" + item.id + "' >\
			 				<div class='content'>\
			 					<h6>" + item.name + "</h6>\
			 					<p>" + item.date + "</p>\
			 				</div>\
			 				<div class='aside'>" + item.slug + "</div>\
			 			</li>"

            if (item.type === 'game') {
                return $(templateGame).appendTo(ul);
            } else {
                return $(template).appendTo(ul);
            }
        },
        _renderMenu: function (ul, items) {
            var that  = this;
            var types = [];
            $.each(items, function (index, item) {
                var type = item.type;
                var li;
                if (types.indexOf(type) > -1) {
                } else {
                    types.push(type);
                    var template     = "<li class='ui-autocomplete-category'>\
									<img src='" + window.finder_icon+ "' width='19' height='16' alt='' />\
									Teams\
								</li>";
                    var templateGame = "<li class='ui-autocomplete-category'>\
										<img src='" + window.finder_icon + "' width='16' height='13' alt='' />\
										Tickets\
									</li>";
                    if (item.type === 'game') {
                        $(templateGame).appendTo(ul);
                    } else {
                        $(template).appendTo(ul);
                    }
                }
                li            = that._renderItemData(ul, item);
                var searchVal = $('.field-autocomplete:focus').val();
                var $label    = $('.ui-autocomplete li h6');
                var reg       = new RegExp(searchVal, 'gi');
                $label.each(function () {
                    var itemText = $(this).text();
                    var txt      = itemText.replace(reg, function (str) {
                        return "<span class='highlight'>" + str + "</span>"
                    });
                    $(this).html(txt);
                })
            });
        },
    });

    $('.js-team-autocomplete').each(function () {
        let input = $(this);
        $(this).catcomplete({
            minLength: 3,
            delay    : 500,
            source   : function (request, response) {
                $.ajax({
                    type    : 'GET',
                    dataType: 'json',
                    url     : window.routes.search.team + '/' + request.term,
                    success : function (data) {
                        response(data);
                    }
                });
            },
            select   : function (event, ui) {
                event.preventDefault();
                $(this).val(ui.item.name);
                // let type     = $(this).attr('data-type');
                // let element  = $('#' + type + '-team');
                // element.val(ui.item.slug);
            },
        });
    });
    //
    // $('.js-search-btn').on('click', function () {
    //
    // });

    // $('#js-search-matches-form').on('submit', function (e) {
        // let baseUrl          = $(this).attr('data-base-url');
        // let homeTeam         = $('.field-home').val() ? '/' + $('.field-home').val() : '';
        // let awayTeam         = $('.field-away').val() ? '/' + $('.field-away').val() : '';
    //     let type             = $(this).attr('data-type') ? '/' + $(this).attr('data-type') : '';
    // })
}
